import React, { useRef, useState } from "react";
import { Table } from "antd";
import { Styles } from "../Config/ThemeConfig";

export function DataTable({
  rowSelections,
  columns,
  data,
  loading,
  bordered,
  rowcheck = false,
  pagination = {},
  onchange,
}) {
  const tableRef = useRef(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    rowSelections(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const { current_page, per_page, total_count } = pagination;
  return (
    <Table
      rowSelection={rowcheck ? rowSelection : undefined}
      columns={columns}
      loading={loading}
      dataSource={data || []}
      bordered={bordered || false}
      size={Styles.table_size}
      scroll={{
        x: 1200,
      }}
      ref={tableRef}
      pagination={{
        current: current_page,
        pageSize: per_page,
        pageSizeOptions: ["10", "20", "30", "40", "50","100"],
        total: total_count,
        onChange: onchange,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
      }}
    />
  );
}
